import { useQuery } from "@tanstack/react-query";
import { staffApi } from "@/api";

export default function Staff() {
  const { data } = useQuery({
    queryKey: ["staff"],
    queryFn: () => staffApi.list(),
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold">担当者管理</h2>
        <p className="text-xs text-slate-400">基幹システムから自動同期</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium">担当者名</th>
              <th className="text-left px-4 py-3 font-medium">姓</th>
              <th className="text-left px-4 py-3 font-medium">メール</th>
              <th className="text-left px-4 py-3 font-medium">ステータス</th>
            </tr>
          </thead>
          <tbody>
            {data?.data.map((staff) => (
              <tr key={staff.id} className="border-b last:border-0 hover:bg-slate-50">
                <td className="px-4 py-3 font-medium">{staff.name}</td>
                <td className="px-4 py-3 text-slate-600">{staff.nameLast || "\u2014"}</td>
                <td className="px-4 py-3 text-slate-500 text-xs">{staff.email || "\u2014"}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${staff.active ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-500"}`}>
                    {staff.active ? "有効" : "無効"}
                  </span>
                </td>
              </tr>
            ))}
            {!data?.data.length && (
              <tr>
                <td colSpan={4} className="px-4 py-8 text-center text-slate-400">
                  担当者が登録されていません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
